import { render, staticRenderFns } from "./my_dialog.vue?vue&type=template&id=2187b966&scoped=true&"
import script from "./my_dialog.vue?vue&type=script&lang=js&"
export * from "./my_dialog.vue?vue&type=script&lang=js&"
import style0 from "./my_dialog.vue?vue&type=style&index=0&id=2187b966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187b966",
  null
  
)

export default component.exports